
import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import { TopicModel } from "@/models/TopicModel";
import { Helpers } from "@/global-scripts/helpers";
import { getModule } from "vuex-module-decorators";
import FilterModule from "@/store/modules/FilterModule";
import ContentModule from "@/store/modules/ContentModule";
import AddToPrintButton from "@/components/AddToPrintButton/AddToPrintButton.vue";
import SearchModule from "@/store/modules/SearchModule";

@Component({
  components: {
    AddToPrintButton,
  },
})
export default class TopicList extends Vue {
  readonly filterModule = getModule(FilterModule, this.$store);
  readonly contentModule = getModule(ContentModule, this.$store);
  readonly searchModule = getModule(SearchModule, this.$store);

  @Prop()
  data!: TopicModel[];

  @Prop()
  highlightKeywords!: boolean;

  onClick(topic: TopicModel) {
    this.$emit("click", topic);
  }

  /**
   * Topic was not matched on title nor lead text
   */
  matchedOnKeywords(topic: TopicModel): boolean {
    return (
      topic.title.indexOf(this.searchModule.searchFilter) === -1 &&
      topic.lead.indexOf(this.searchModule.searchFilter) === -1
    );
  }

  getTopicUrlName(topic: TopicModel): string {
    return Helpers.urlFriendlyName(topic.title);
  }

  getTopicCategoryPath(topic: TopicModel) {
    return Helpers.categoryBreadCrumb(topic.parentNodes[0], this.contentModule.filteredCategories);
  }

  /**
   * Local helper for outputting data values with
   * filtered text, ie marking up matches
   */
  highlight(value: string): string {
    return this.highlightKeywords ? Helpers.getFilteredDataProp(value, this.searchModule.searchFilter) : value;
  }

  getTopicPath(topic: TopicModel) {
    return `${this.filterModule.basePath}/${this.getTopicCategoryPath(topic)}${this.getTopicUrlName(topic)}/`;
  }

  getFilterClass(topic: TopicModel) {
    const classList = [];

    classList.push(Helpers.getFilterClass(topic));

    if (this.$validityHelper.topicIncludeNews(topic, this.filterModule.activeFilters)) {
      classList.push("news");
    }

    return classList.join(" ");
  }
}
